import "./style.css";

import MGStatefulTextBox from "./MGStatefulTextBox";

import { ErrorMessage } from "formik";
import { MGHelperText } from "@/components/typography";
import PropTypes from "prop-types";
import MGField from "../BuildingBlocks/MGField";

export const MGStatefulTextBoxField = ({
  name,
  icon,
  actionIcon,
  onAction,
  isLoading,
  emitOnChangeOnlyOnEnter,
  onChange,
  clearable,
  placeholder,
  inline,
}) => {
  return (
    <>
      <MGField name={name} inline={inline}>
        {({ meta, field, form }) => {
          const onChangeHandler = (evt) => {
            form.setFieldValue(field.name, evt);
            if (typeof onChange === "function") onChange(evt);
          };

          return (
            <>
              <MGStatefulTextBox
                placeholder={placeholder}
                icon={icon}
                isLoading={isLoading}
                actionIcon={actionIcon}
                onAction={onAction}
                clearable={clearable}
                value={field.value}
                emitChangeOnlyOnEnter={emitOnChangeOnlyOnEnter}
                onChange={(evt) => {
                  onChangeHandler(evt);
                }}
                formikField={field}
                formikMeta={meta}
              ></MGStatefulTextBox>
            </>
          );
        }}
      </MGField>
      <ErrorMessage component={MGHelperText} name={name} />
    </>
  );
};

MGStatefulTextBoxField.propTypes = {
  name: PropTypes.string,
  icon: PropTypes.string,
  actionIcon: PropTypes.string,
  onAction: PropTypes.func,
  onChange: PropTypes.func,
  clearable: PropTypes.bool,
  placeholder: PropTypes.string,
  inline: PropTypes.bool,
};

MGStatefulTextBoxField.defaultProps = {
  clearable: true,
};

export default MGStatefulTextBoxField;
